<odl-dialog [open]="isOpen()" (odl-close)="handleCloseDialog()">
  <div slot="header" class="text-info__header" [class.more_info]="showMoreInfo()">
    @if (showMoreInfo()) {
      <odl-button
        id="text-info-back-button"
        class="text-info__header-back-button"
        [description]="'BACK' | translate"
        (click)="closeMoreInfo()"
      >
        <odl-icon name="navigate_back" slot="only-icon"></odl-icon>
      </odl-button>
      <span class="text-info__header-title">{{ moreInfoTitle() | translate }}</span>
    } @else {
      <span class="text-info__header-title" nrEllipsis>{{ selectedText() }}</span>
    }
    <odl-button
      id="text-info-close-button"
      class="text-info__header-close-button"
      [description]="'CLOSE' | translate"
      (click)="handleCloseDialog()"
    >
      <odl-icon name="close" slot="only-icon"></odl-icon>
    </odl-button>
  </div>
  <div #body class="text-info__body">
    <div #bodyContent class="text-info__body-content">
      @if (isResolved()) {
        <div class="text-info__content">
          <div class="text-info__content-slides">
            <div class="text-info__content-slides-slide" [class.hidden]="showMoreInfo()">
              <nr-text-info-content
                [textInfo]="textInfoResponse()?.textInfo"
                [initialTranslation]="translation()"
                [fallbackText]="selectedText()"
                [hasDictionaryInfo]="hasDictionaryInfo()"
                [isWiktionaryResponse]="isWiktionaryResponse()"
                (showMoreInfo)="this.showMoreInfo.set($event)"
              />
            </div>

            <div class="text-info__content-slides-slide" [class.hidden]="!showMoreInfo()">
              <div class="text-info__content-slides-slide-more-info">
                @if (showMoreInfo() === 'wikipedia') {
                  <div
                    class="text-info__content-slides-slide-more-info-text"
                    [innerHTML]="wikipediaHtml()"
                  ></div>
                } @else if (isWiktionaryResponse()) {
                  <div
                    class="text-info__content-slides-slide-more-info-text"
                    [innerHTML]="wiktionaryHtml()"
                  ></div>
                } @else {
                  <p class="text-info__content-slides-slide-more-info-text">
                    {{ textInfoResponse()?.textInfo?.definition }}
                  </p>
                  <small class="text-info__content-slides-slide-more-info-ai-info">
                    {{ 'WORD_INFO.AI_INFO' | translate }}
                  </small>
                }
              </div>
            </div>
          </div>
        </div>
      } @else {
        <nr-text-info-skeleton />
      }
    </div>
  </div>
</odl-dialog>

@if (showMoreInfo()) {
  <odl-tooltip for="#text-info-back-button">{{ 'BACK' | translate }}</odl-tooltip>
}
<odl-tooltip for="#text-info-close-button">{{ 'CLOSE' | translate }}</odl-tooltip>
